import type { LucideIcon } from "lucide-react";

type SectionDividerProps = {
  icon: LucideIcon
  label: string
};

export const SectionDivider = ({ icon: Icon, label }: SectionDividerProps) => (
  <div className="flex items-center gap-2.5">
    <div className="flex h-[22px] w-[22px] shrink-0 items-center justify-center rounded-md bg-gray-50 dark:bg-gray-800">
      <Icon size={12} className="text-gray-400 dark:text-gray-500" aria-hidden />
    </div>
    <span className="text-[11px] font-semibold uppercase tracking-[1.2px] text-gray-400 dark:text-gray-500">
      {label}
    </span>
    <div className="h-px flex-1 bg-gray-200 dark:bg-gray-700" />
  </div>
);

SectionDivider.displayName = "SectionDivider";
